import { Alert, AlertColor, Snackbar, SnackbarOrigin, Typography, useMediaQuery } from "@mui/material";
import { ReactNode, useEffect } from 'react';

interface Props {
  severity?: AlertColor;
  msg?: string | JSX.Element;
  open?: boolean;
  onClose?: () => void;
  anchorOrigin?: SnackbarOrigin;
  closeTime?: number;
  title?: string | JSX.Element;
  action?: ReactNode;
}

export const AlertComp = ({
  severity = "success",
  msg = '',
  open = true,
  onClose,
  anchorOrigin,
  closeTime = 2000,
  title,
  action
}: Props) => {
  const isDesktop = useMediaQuery('(min-width:1024px)');

  useEffect(() => {
    const timer = open && closeTime ? setTimeout(() => {
      if (onClose) {
        onClose();
      }
    }, closeTime) : undefined;

    return () => {
      clearTimeout(timer);
    };
  }, [onClose, open, closeTime]);

  const defaultAnchorOrigin: SnackbarOrigin = isDesktop
    ? { vertical: "top", horizontal: "right" }
    : { vertical: "top", horizontal: "center" };

  if (!msg || !open) return null;

  return (
    <Snackbar
      anchorOrigin={anchorOrigin ?? defaultAnchorOrigin}
      open={open}
      onClose={onClose}
      data-automation="toast-popup"
    >
      <Alert
        icon={false}
        onClose={onClose}
        severity={severity}
        action={action}
        sx={action ? {
          display: "flex",
          flexDirection: "column",
          "& .MuiAlert-action": {
            m: 0,
            alignSelf: 'center'
          },
        } : undefined}
      >
        {title && <Typography className="title" data-automation="toast-title">{title}</Typography>}
        <Typography
          sx={{ '& a': { color: 'corporateBlue', fontWeight: 'bold' } }}
          component='div'
          data-automation="toast-msg"
        >
          {msg}
        </Typography>
      </Alert>
    </Snackbar>
  );
};
